import { useDidMount } from '@djs/react';
import { linkIosManifest } from '../PwaInstallSafari/helpers';
import { getPageKey } from './getPageKey';
import { MyTrackerEvents, sendMtEvent, sendYaMetrikaEvent, YaMetrikaEvents } from '../../core/services/myTracker';
import { useAppContext } from '../../core';
import { PwaPage } from './enums';

const PAGE_MAP_TO_TRACKER_EVENTS: { [key in PwaPage]: { mt: MyTrackerEvents; ym: YaMetrikaEvents } } = {
  [PwaPage.DisabledIos]: {
    mt: MyTrackerEvents.PwaIosInstallDisabled,
    ym: YaMetrikaEvents.PwaIosInstallDisabled,
  },
  [PwaPage.DisabledAndroid]: {
    mt: MyTrackerEvents.PwaAndroidInstallDisabled,
    ym: YaMetrikaEvents.PwaAndroidInstallDisabled,
  },
  [PwaPage.InstallSafari]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallUnavailableOnOldIos]: {
    mt: MyTrackerEvents.PwaOldIosInstructionOpened,
    ym: YaMetrikaEvents.PwaOldIosInstructionOpened,
  },
  [PwaPage.InstallOldSafari]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallChrome]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallYandex]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallOther]: {
    mt: MyTrackerEvents.PwaCopyInstructionOpened,
    ym: YaMetrikaEvents.PwaCopyInstructionOpened,
  },
  [PwaPage.InstallDesktop]: {
    mt: MyTrackerEvents.PwaQrInstructionOpened,
    ym: YaMetrikaEvents.PwaQrInstructionOpened,
  },
};

export function usePwaInstallControllerState() {
  const { deviceInfo } = useAppContext();
  const pageKey = getPageKey(deviceInfo);

  useDidMount(() => {
    if (deviceInfo.mobileOS?.name === 'ios') {
      linkIosManifest();
    }
  });

  useDidMount(() => {
    const event = PAGE_MAP_TO_TRACKER_EVENTS[pageKey];
    sendMtEvent(event.mt);
    sendYaMetrikaEvent(event.ym);
  });

  return pageKey;
}
